import { Lock } from '@mui/icons-material'
import { type SxProps, Tooltip } from '@mui/material'
import { type ActivityLock } from '../../../models/ActivityLock'
import { useAuth } from '../../../hooks/use-auth'
import { TranslateDate } from '../../../utils/dateUtils'

interface Props {
  lock: ActivityLock | undefined
  sx?: SxProps
  children?: React.ReactNode
}

export const LockedActivityActionTooltip = (props: Props): JSX.Element => {
  const { user } = useAuth()

  const localLockTime = TranslateDate(props.lock?.lockedUntil ?? new Date())
  const activityIsLocked = props.lock != null && props.lock.lockedBy.id !== user?.id && localLockTime > new Date()

  const LockText = (lock: ActivityLock | undefined): string => {
    return `${lock?.lockedBy.fullName ?? ''} is editing until ${localLockTime.toLocaleTimeString() ?? ''}`
  }

  return <>
    {activityIsLocked &&
      <Tooltip arrow={true} title={LockText(props.lock)} slotProps={{ tooltip: { sx: { fontSize: '1em' } } }}>
        <Lock sx={props.sx} />
      </Tooltip>
    }

    {!activityIsLocked &&
      props.children
    }
  </>
}
